import { render, staticRenderFns } from "./Shapes.vue?vue&type=template&id=965c7ece&"
import script from "./Shapes.vue?vue&type=script&lang=js&"
export * from "./Shapes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports